export enum ChipTheme {
  DEFAULT = 'default',
  ACTIVE = 'active',
  POPULAR = 'popular',
  LIGHT = 'light',
}
